/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { FontAwesomeIconWrapper } from "cms/icons/fa-icon/index";

const DialogPanel = (props) => {
    
    const {
        icon,
        setIcon,
        onSelectIcon,
    } = props;
    
    
    return (
        <Fragment>
            <div className='icon-select-container'>
                <div className="icon-select-panel">
                    <div className="icon-select-instruction">
                        Please search for the name of an icon and select one.
                    </div>
                    <FontAwesomeIconWrapper
                        icon={icon}
                        setIcon={setIcon}
                        onChangeIcon={onSelectIcon}
                    />
                </div>
            </div>
        </Fragment>
    );
};

export { DialogPanel };
